import { useLocale } from "@/hooks/useLocale";
import { SeriousAboutTalent } from "@/ui/SeriousAboutTalent";
import Image from "@/ui/Image";
import { Col } from "react-bootstrap";
import YoutubeVideoModal from "@/ui/YoutubeVideoModal";
import { getGlobal } from "@/functions/getGlobal";
import { stripTags } from "@/functions/stripTags";
import SourceFlowText from "@sourceflow-uk/sourceflowtext";

export const CulturePageContentSection = ({ className }) => {
  const locale = useLocale();
  const global = getGlobal();

  return (
    <SeriousAboutTalent
      className={className}
      tag={`page.culture.content.tag.${locale}`}
      title={`page.culture.content.title.${locale}`}
      text={`page.culture.content.text.${locale}`}
      details={`page.culture.content.details.${locale}`}
      variant="quaternary"
    >
      <Col xs={12} lg={6}>
        {/* START: CMS Tools editable fix */}
        <SourceFlowText
          global={global}
          path={`page.culture.content.video.${locale}`}
          type="text"
          className="visually-hidden"
        />
        {/* END: CMS Tools editable fix */}
        <YoutubeVideoModal
          video_embed_url={stripTags(global[`page.culture.content.video.${locale}`]).trim()}
          variant="quaternary"
        >
          <div className="ratio ratio-4x3 mt-4">
            <Image
              img={{
                path: "page.culture.content.image",
                src: "/assets/culture/content/1.jpg",
              }}
              size="x650"
              alt=""
              style={{ objectFit: "cover", objectPosition: "center right" }}
            />
          </div>
        </YoutubeVideoModal>
      </Col>
    </SeriousAboutTalent>
  );
};

CulturePageContentSection.defaultProps = {
  className: "py-4 py-md-5",
};
